export enum EMajorAreaThemeOrder {
  Alphabetical = 'ALFABETICA',
  Default = 'PADRAO',
}
